import FastPaymentModal from './FastPaymentModal';

export default FastPaymentModal;
